import React from 'react'
import RestaurantProductContainer from '../../../../Components/ProductRegisterPart/RestaurantProductContainer/RestaurantProductContainer'
import Layout from '../../Layout'

const RestaurantProduct = () => {
    return (
      <Layout>
        <RestaurantProductContainer/>
      </Layout>
    )
}

export default RestaurantProduct